// @restworld/ui-components - Molecules & organisms layer
// Components migrated from @restworld/ui-ds

export * from './lib/alert';
export * from './lib/association-badge';
export * from './lib/wrapper';
export * from './lib/switch';
export * from './lib/skeleton-loading';
export * from './lib/drawer';
export * from './lib/modal-message';
export * from './lib/bot-challenge-host';

// Legacy re-exports from @restworld/ui-ds
// These components have not yet been rewritten and are re-exported here
// so that apps never import directly from @restworld/ui-ds.
// TODO: Gradually replace with proper Tailwind/shadcn implementations.
export * from './legacy';
